import { render } from "./wordScrollList.vue?vue&type=template&id=69066e18&scoped=true"
import script from "./wordScrollList.vue?vue&type=script&lang=js"
export * from "./wordScrollList.vue?vue&type=script&lang=js"

import "./wordScrollList.vue?vue&type=style&index=0&id=69066e18&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69066e18"]])

export default __exports__